var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.warningZone)?_c('JcdcAlert',{attrs:{"type":"warning"}},[_c('strong',[_vm._v("Session Timeout!")]),_vm._v(" Still there? In "),_c('strong',[_vm._v(_vm._s(_vm.countdown > 59 ? Math.round(_vm.countdown / 60) + 'm' : _vm.countdown + 's'))]),_vm._v(", you will be logged out due to inactivity. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }